import React from 'react';
import { KeyboardDetectionProvider } from '@spotify-internal/encore-web';
import { ColorSetWrapper } from '../../ui/Colors/Colors';
import { LinkGrid } from '../../ui/Components/LinkGrid';
export const LinkGridModule = React.forwardRef(({ headline, colors, subtext, items }, ref) => {
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(ColorSetWrapper, { colors: colors },
            React.createElement("div", { ref: ref },
                React.createElement(LinkGrid, { headline: headline, subtext: subtext, items: items, trackCategory: "Link Grid Module", placeholders: false, featured: false })))));
});
